import Vue from 'vue'
import { autoZero, toThousands, dateFormat, timeText } from './functions'

Vue.filter('autoZero', autoZero)

Vue.filter('toThousands', toThousands)

Vue.filter('dateFormat', dateFormat)

Vue.filter('timeText', timeText)



// WEBPACK FOOTER //
// ./src/assets/js/filters.js